import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';
import UiEnergyLabelLink from '~/components/ui/UiEnergyLabelLink.vue';
import UiLink from '~/components/ui/UiLink.vue';
import { computed } from 'vue';
import { getProductFeatureValueById } from '~/helpers/vue';

interface Props {
  image?: any;
  name?: string;
  description?: string;
  isNew?: boolean;
  link?: string;
  tags?: any[];
  featureGroups?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogProductCard',
  props: {
    image: { default: () => ({}) },
    name: { default: '' },
    description: { default: '' },
    isNew: { type: Boolean, default: false },
    link: { default: '' },
    tags: { default: () => [] },
    featureGroups: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { image: any, name: string, description: string, isNew: boolean, link: string, tags: any[], featureGroups: any[] };



const energyLabelLink = computed(() =>
  getProductFeatureValueById(
    'ADDITIONAL_INFORMATION',
    'EPREL',
    props.featureGroups,
  ),
);

const energyLabelSymbol = computed(() =>
  getProductFeatureValueById(
    'ADDITIONAL_INFORMATION',
    'ENERGY_LABEL',
    props.featureGroups,
  ),
);

return { __sfc: true,props, energyLabelLink, energyLabelSymbol, CdnImg, handleImageSrc, handleImageAlt, UiEnergyLabelLink, UiLink }
}

})